import { buildQteAttributes } from './buildQteAttributes';

import { ProductType } from '~/core/enums';
import {
  ApplianceModel,
  ColorModel,
  CornerRadiusModel,
  DiagonalCornerModel,
  EdgeModel,
  ProductDetails,
  TearOutModel,
  WaterfallLabor,
} from '~/core/models';

type Product =
  | ColorModel
  | ApplianceModel
  | EdgeModel
  | TearOutModel
  | DiagonalCornerModel
  | CornerRadiusModel
  | WaterfallLabor;

// TODO: add tests to validate different cases
export const convertProductsToProductDetailsList =
  (productType: ProductType) =>
  (products: Product[]): ProductDetails[] =>
    products.map((product) => {
      const productDetails: ProductDetails = {
        ...product,
        abbrevDesc: product.abbrevDesc,
        consumerDesc: product.consumerDesc,
        expirationPromotionDate: product.expirationPromotionDate
          ? new Date(product.expirationPromotionDate)
          : undefined,
        name: product.name,
        price: product.price,
        priceWithoutDiscount: product.priceWithoutDiscount ?? product.price,
        productId: product.productId,
        productType,
        unitOfMeasure: product.unitOfMeasure,
        ...buildQteAttributes(product),
      };

      return productDetails;
    });
